import $ from 'jquery';
import EventsDetailTicketSelector from './EventsDetailTicketSelector';
import AdditionalEventsSelector from './AdditionalEventsSelector';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import { loadModal } from '../../AsyncLoader';

/** @typedef {import('./types').TicketSelectorOptions} TicketSelectorOptions */
/** @typedef {import('./types').PerformanceConfiguration} PerformanceConfiguration */


const { FieldValidationProvider } = window.tnew.lib;

class EventDetail {
  /**
   * @param {object} param0
   * @param {string} param0.formSelector
   * @param {TicketSelectorOptions} param0.ticketSelectorOptions
   * @param {boolean} param0.isSeatMapModalVisible
   * @param {PerformanceConfiguration} param0.performanceConfiguration
   */
  constructor({ formSelector, ticketSelectorOptions, isSeatMapModalVisible, performanceConfiguration }) {
    const $form = document.querySelector(formSelector);

    const validationProvider = FieldValidationProvider.createStandardProvider($form, '.tn-ticket-selector__additional-controls');

    this.ticketSelector = new EventsDetailTicketSelector($form, ticketSelectorOptions, performanceConfiguration, validationProvider);
    this.additionalEventsSelector = new AdditionalEventsSelector();


    const $labels = $('.tn-detail-production-text-show-link, .tn-detail-production-text-hide-link');
    $('.tn-detail-production-text-toggle-link').on('click', () => {
      $labels.toggleClass('hide');
    });

    if (isSeatMapModalVisible) {
      this.initSeatMapModal();
    }
  }

  async initSeatMapModal() {
    const $btn = $('.tn-event-detail__btn-view-seat-map-modal');
    const $dialogBody = $('#tn-event-detail-seat-map-modal-body');

    $dialogBody.remove().show();

    const Modal = await loadModal();

    const { title, labelBtnAccept } = this.getSeatMapModalProperties();

    $btn.on('click', () => {
      Modal.alert({
        className: 'tn-ticketing-module-map-modal',
        title,
        labelBtnAccept,
        bodyContents: $dialogBody,
        returnFocusTo: $btn[0],
      });
    });
  }

  getSeatMapModalProperties() {
    const key = ComponentKeys.STATIC_BEST_AVAILABLE;

    return {
      title: ContentStorage.get(key, 'Heading'),
      labelBtnAccept: ContentStorage.get(key, 'SeatMapModalCloseButtonText'),
    };
  }
}

window.tnew.EventDetail = EventDetail;

export default EventDetail;



// WEBPACK FOOTER //
// ./src/events/detail/EventDetail.js